import { collections as collectionConst } from '@edulastic/constants'
import { PEAR_ASSESSMENT_CERTIFIED_NAME } from '@edulastic/constants/const/common'
import { isNonPaidPremiumId } from './nonPaidPremiumCollections'

const { PREMIUM, CUSTOM } = collectionConst.types

/** Free-scope option values from collectionDefaultFilter / collectionPublicFilter */
const FREE_FIXED_VALUES = ['INDIVIDUAL', 'SCHOOL', 'DISTRICT', 'PUBLIC']

/** Same shape as Question Type dropdown separator in Item Library Search */
export const COLLECTIONS_FILTER_SEPARATOR = {
  value: 'dash',
  text: '--------------------',
  disabled: true,
}

const alphaByText = (a, b) =>
  (a.text || '').toLowerCase().localeCompare((b.text || '').toLowerCase())

const isPaidPremiumOrCustom = (type, id) =>
  type === CUSTOM || (type === PREMIUM && !isNonPaidPremiumId(id))

const toSelectOption = (scope) => ({
  value: scope.value,
  text: scope.text,
})

const bankToSelectOption = (bank) => ({
  value: bank._id,
  text: bank.name,
})

/**
 * Order Collections filter options for Test / Item library filters.
 * Classifies scope rows and org item banks into buckets, then emits select options.
 * Callers must pass already visibility-trimmed inputs; this does not apply role filters.
 *
 * @param {Array<{ value: string, text: string }>} scopeOptions Library scope rows (Private, School, …) without All Collections
 * @param {Array<{ _id: string, name: string, type?: string }>} banks Org item banks from getCollectionsSelector
 * @returns {Array<{ value: string, text: string, disabled?: boolean }>}
 */
export const sortCollectionsForLibraryFilter = (
  scopeOptions = [],
  banks = []
) => {
  if (!scopeOptions.length && !banks.length) {
    return []
  }

  const premiumCustom = []
  const freeFixedByValue = {}
  const pearOptions = []
  const remainder = []

  scopeOptions.forEach((scope) => {
    if (!scope?.value || scope.value === 'dash') {
      return
    }

    if (FREE_FIXED_VALUES.includes(scope.value)) {
      freeFixedByValue[scope.value] = toSelectOption(scope)
    }
  })

  banks.forEach((bank) => {
    if (!bank?._id) {
      return
    }

    const option = bankToSelectOption(bank)
    const { type, name, _id } = bank

    if (isPaidPremiumOrCustom(type, _id)) {
      premiumCustom.push(option)
      return
    }

    if (name === PEAR_ASSESSMENT_CERTIFIED_NAME) {
      pearOptions.push(option)
      return
    }

    remainder.push(option)
  })

  premiumCustom.sort(alphaByText)
  remainder.sort(alphaByText)

  const freeFixed = FREE_FIXED_VALUES.map(
    (value) => freeFixedByValue[value]
  ).filter(Boolean)

  const result = [...premiumCustom]
  if (premiumCustom.length > 0) {
    result.push({ ...COLLECTIONS_FILTER_SEPARATOR })
  }
  result.push(...freeFixed, ...pearOptions, ...remainder)
  return result
}

export default sortCollectionsForLibraryFilter
